export default class CommunesApiDriveService {
  path = "/api/communes";

  constructor(httpApi) {
    this.httpApi = httpApi;
  }

  /**
   * Détail d'une commune
   * @param {Number} id
   */
  async commune(id) {
    const res = await this.httpApi.get(`${this.path}/${id}`);
    return res.data;
  }

  /**
   * Liste des communes
   * @param {Object} params - lat, long, code_postal, code_insee, page, limit, order
   */
  async communes(params = {}) {
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.get(this.path, config);
    return res.data.data;
  }
}
